import type { CreditBlockClient } from '../../types';

export function resolveClientPickId(c: CreditBlockClient): string {
  const id = String(c.id ?? '').trim();
  if (id) return id;
  return String(c.arrayInfo?.clientKey ?? '').trim();
}

export function mergeClientsByPickId(...lists: CreditBlockClient[][]): CreditBlockClient[] {
  const byPick = new Map<string, CreditBlockClient>();
  for (const list of lists) {
    for (const c of list) {
      const pid = resolveClientPickId(c);
      if (!pid) continue;
      if (!byPick.has(pid)) byPick.set(pid, c);
    }
  }
  return Array.from(byPick.values());
}
